import { Button } from 'base/ui/button';
import { IconPageAi, IconSitemapAi } from 'base/ui/icons';
import { TextSmall, TextTinyLight } from 'base/ui/typography';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { ProjectEditingActions } from '../editing_actions/project';
import { SelectionStore } from '../selection/store';
import { ProjectSession } from '../session/session';
import { SidebarNavigation } from '../sidebar/routes';
import styles from './ai_generate_header.css';

export const AiGenerateHeader = observer(function _AiGenerateHeader({
  session,
  selection,
  editing,
  navigation,
}: {
  session: ProjectSession;
  selection: SelectionStore;
  editing: ProjectEditingActions;
  navigation: SidebarNavigation;
}) {
  const sel = selection.get();
  if (sel.section) {
    return null;
  }

  return (
    <div className={styles.buttons}>
      <GenerateCard
        title="Sitemap"
        icon={IconSitemapAi}
        onClick={() => {
          editing.addSpaceAfter(sel.space ?? 'home');
          navigation.goto({ path: 'edit' });
        }}
      />
      <GenerateCard
        title="Page"
        icon={IconPageAi}
        onClick={() => {
          editing.addPageNatural();
          navigation.goto({ path: 'edit' });
        }}
      />
    </div>
  );
});

function GenerateCard({
  title,
  icon: Icon,
  onClick,
}: {
  title: string;
  icon: React.ComponentType;
  onClick: () => void;
}) {
  return (
    <Button onClick={onClick} size="large">
      <div className={styles.generateCard}>
        <div className={styles.generateCardIcon}>
          <Icon />
        </div>
        <TextTinyLight color="grey">Generate a new</TextTinyLight>
        <TextSmall>{title}</TextSmall>
      </div>
    </Button>
  );
}
